import ApiGetOptions from '@/datatypes/api-get-options';
import ApiPutOptions from '@/datatypes/api-put-options';
import ApiService from '@/services/api/ApiService';
import decamelizeKeysDeep from 'decamelize-keys-deep';

export default class SystemSettingsService extends ApiService {
  public getSettings(options) {
    return this.call(new ApiGetOptions({
      url: '/system_settings',
      params: options,
    }));
  }

  public updateEmailProvider(emailProvider) {
    return this.call(new ApiPutOptions({
      url: 'system_settings/update',
      data: decamelizeKeysDeep({ emailProvider }),
    }));
  }
}
